<template>
  <header class="mudra-header">
    <div class="mudra-brand">
      <img src="@/assets/Mudra-logo.png" alt="Mudra Logo" class="mudra-logo" />
      <span class="mudra-name">Mudra</span>
    </div>
    <div class="mudra-user-info" v-if="full_name || tokens !== null">
      <span v-if="full_name" class="mudra-full_name">{{ full_name }}</span>
      <div v-if="tokens !== null" class="mudra-balance">
        <span class="balance-currency">MDR</span>
        <span class="balance-amount">{{ tokens }}</span>
      </div>
    </div>
  </header>
</template>

<script setup>
defineProps({
  tokens: {
    type: Number,
    default: null
  },
  full_name: {
    type: String,
    default: ''
  }
});
</script>

<style scoped>
.mudra-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #BB6622, #A14F1A);
  padding: 6px 16px;
  height: 48px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  color: white;
}

.mudra-brand {
  display: flex;
  align-items: center;
}

.mudra-logo {
  height: 30px;
  width: 30px;
  margin-right: 10px;
}

.mudra-name {
  font-size: 20px;
  font-weight: 600;
}

.mudra-user-info {
  display: flex;
  align-items: center;
}

.mudra-full_name {
  margin-right: 10px;
  font-size: 14px;
}

.mudra-balance {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 10px;
  border-radius: 16px;
}

.balance-currency {
  margin-right: 6px;
  color: #FFD700;
  font-weight: 700;
}

.balance-amount {
  font-weight: 600;
}
</style>